import { useState, useEffect } from 'react';
import { Select } from 'antd';
import { useSelector } from "react-redux";
import utils from './utils';

const AccountSelect = ({ value = [], onChange, multiple = false, size = null, minWidth = 200, placeholder = 'Izberi račun', defaultOpen = false, autoFocus = false, popupMatchSelectWidth, autoPreselect = true }) => {
  const [open, setOpen] = useState(defaultOpen);

  const accounts = useSelector(state => state.Account.list);
  const opts = utils.processBackendOpts(accounts);

  // Preselect default if nothing is selected
  useEffect(() => {
    // console.log('accounts', accounts)
    if (autoPreselect && (!value || (Array.isArray(value) && value.length === 0)) && !multiple) {
      const defaultAcc = accounts.find(acc => acc.is_default);
      if (defaultAcc && onChange) {
        onChange(defaultAcc.id);
      }
    }
  }, [accounts, value, multiple, onChange, autoPreselect]);

  return (
    <Select
      size={size}
      open={open}
      autoFocus={autoFocus}
      popupMatchSelectWidth={popupMatchSelectWidth}
      onDropdownVisibleChange={setOpen}
      mode={multiple ? "tags" : undefined}
      showSearch
      style={{ minWidth: minWidth, flex: 1}}
      placeholder={placeholder}
      optionFilterProp="label"
      value={value}
      onChange={onChange}
      options={opts}
      allowClear
    />
  );
};

export default AccountSelect;
